<template>
  <div>
    <v-dialog fullscreen v-model="loading" full-width>
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-layout justify-center align-center>
          <img
            src="https://taybull-public.s3-eu-west-1.amazonaws.com/lg.hexagon-grid-loader.gif"
          />
        </v-layout>
      </v-container>
    </v-dialog>
    <div
      ref="printMe"
      :style="chart.breakpoint.style"
      :class="
        mode != 'view' ? 'edit-mode layout-container' : 'layout-container'
      "
    >
      <LeftLinksLayout
        :chart="chart"
        :row="row"
        :mode="mode"
        :key="chart.id + loadTime"
        v-if="
          chart &&
          chart.parameters &&
          chart.parameters.layoutTemplate != null &&
          chart.parameters.layoutTemplate.value == 'left-links'
        "
      />
      <TopLinksLayout
        :key="chart.id + loadTime"
        :chart="chart"
        :row="row"
        :mode="mode"
        v-else
      />
    </div>
  </div>
</template>

<script>
// import LeftLinkLayout from './layouts/LeftLinkLayout.vue';
// import Layers from '@/components/Layers.vue';

const LeftLinksLayout = () => import("./layouts/LeftLinks.Layout.vue");
const TopLinksLayout = () => import("./layouts/TopLinks.Layout.vue");

import { createNamespacedHelpers } from "vuex";

const chartNamespace = createNamespacedHelpers("charts");
// const VueGridLayout = () => import('vue-grid-layout');

export default {
  name: "TaybullLayout",
  props: ["chart", "row", "mode"],
  data: function () {
    return {
    };
  },
  components: {
    LeftLinksLayout,
    TopLinksLayout,
  },
  computed: {
    ...chartNamespace.mapState({
      loadTime: (state) => state.loadTime,
      loading: (state) => state.loading,
    }),
  },
  methods: {},
  mounted: function () {
  },
  destroyed() {
  },
  beforeCreate: function () {},
};
</script>
